import styled from 'styled-components';
import Variables from 'styles/Variables';

export const Title = styled.h1`
	font-size: 1.25rem;
	font-weight: 600;
	margin-bottom: 1rem;
`;

export const Footer = styled.div`
	align-items: center;
	display: flex;
	gap: 0.75rem;
	justify-content: center;
	margin-top: 1.5rem;
`;

export const RefundNote = styled.p`
	align-items: center;
	color: #8c8c8c;
	display: flex;
	font-size: 0.9rem;
	gap: 0.4rem;
	justify-content: center;
	margin-top: 1.25rem;

	svg {
		flex-shrink: 0;
	}
`;

export const DownloadAllButton = styled.button`
	align-items: center;
	background: none;
	border: 2px solid ${Variables.colors.main};
	border-radius: 0.5rem;
	color: ${Variables.colors.main};
	cursor: pointer;
	display: flex;
	font-family: inherit;
	font-size: 0.875rem;
	font-weight: 600;
	gap: 0.5rem;
	padding: 0.5rem 1rem;
	transition: background 0.2s, color 0.2s;

	&:hover {
		background: ${Variables.colors.main};
		color: #fff;
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;
